import React from 'react';
import './LawncareDetails.css';
import { Link } from "react-router-dom";

const residentialServices = [
  {
    title: '1-Year Residential Landscaping Maintenance Package',
    content: [
      `This weekly, year-round service keeps your property in top shape through all seasons. With 12 equal monthly payments, you get consistent lawn care without surprise charges or hidden fees.`,
      `The one-year contract includes reliable service, and the first month comes with no commitment, giving you a chance to see the quality of the work before continuing. Five package options are available to match the size and needs of your property.`,
      `Each package includes mowing, edging, debris cleanup, flower bed maintenance, trimming, leaf raking, and optional quarterly fertilization to keep your lawn healthy, clean, and well-maintained.`,
    ],
    disclaimer: {
      title: 'First Service Disclaimer',
      text: `Please note that the first service may cost more depending on the current state of your property. If your lawn or landscape requires additional work to bring it up to standard (such as excessive weeding, debris removal, or lawn restoration), the first service will be priced higher. After the initial service, future maintenance will be charged at the regular rate once your property is properly maintained.`,
    },
  },
  {
    title: 'Custom Residential Lawn Care Package (Sizes May Vary)',
    content: [
      `This option is designed for homeowners who want a flexible, personalized approach to lawn maintenance. You choose the contract length that works best for your needs: monthly, quarterly, or annually. Because this package allows for more customization and a shorter commitment, pricing is higher than our standard one-year plan.`,
    ],
    features: [
      {
        text: 'Flexible Contract Length – Choose a contract that fits your schedule and property needs, whether on a quarterly, 6 month, or yearly basis.',
      },
      {
        text: 'Full Property Maintenance – Weekly services include mowing, edging, debris cleanup, flower bed control, and trimming.',
      },
      {
        text: 'Due to the flexibility the custom package offers, the price is higher than the other 4 packages.',
      },
    ],
    badge: 'Most Flexible',
  },
  {
    title: 'Monthly Residential Package – Starts at $249/month',
    content: [
      'Monthly Residential Package – Starts at $249/month. This package includes essential weekly maintenance to keep your yard looking clean and well-maintained. Additional services can be added to any package for an extra cost.',
    ],
    features: [
      {
        text: 'Mowing – Keeps your lawn at the right height, encouraging healthy growth and preventing thatch buildup.',
      },
      {
        text: 'Edging – Defines borders along sidewalks, driveways, and garden beds to maintain a crisp, clean look.',
      },
      {
        text: 'Blowing Off Debris – Clears leaves, grass clippings, and dirt from all hard surfaces to maintain a neat appearance.',
      },
      {
        text: 'Weeding & Flower Bed Control – Regular weeding prevents unwanted plants from overtaking your garden.',
      },
      {
        text: 'Trimming – Shapes shrubs, bushes, and small trees, keeping your landscape neat and uniform.',
      },
      {
        text: 'Raking Fallen Leaves – Regular leaf raking prevents buildup that can smother your grass, keeping your lawn healthy and looking neat.',
      },
      {
        text: 'Quarterly Fertilization (add‑on) – This service provides essential nutrients to your lawn, ensuring it stays lush and healthy throughout the year.',
      },
      {
        text: 'Irrigation System Check – We inspect and tune your sprinklers to ensure efficient watering, preventing dry spots and water waste.',
      },
      {
        text: 'Seasonal Planting Advice – Personalized guidance on seasonal flowers and plants to keep your landscape vibrant all year.',
      },
    ],
    badge: 'Popular Choice',
  },
  {
    title: 'Why Choose Primed Landscaping?',
    features: [
      {
        text: 'Reliable Weekly Service Consistent, year-round maintenance keeps your yard looking its best.',
      },
      {
        text: 'Straightforward Pricing Flat monthly payments with no surprise fees. Custom packages are priced based on flexibility.',
      },
      {
        text: 'No-Commitment First Month (One-Year Plan Only) Try the full-service annual plan for a month before deciding to continue.',
      },
      {
        text: "Flexible Options Choose from standard or custom packages that match your property and schedule",
      },
      {
        text: 'Eco‑Friendly Practices – We use organic products and water‑smart methods to keep your lawn healthy, safe for kids and pets, and kind to the planet.',
      },
      {
        text: 'Satisfaction Guaranteed We\'re not done until the work meets your expectations.',
      },
    ],
    closing: `Choose our residential lawn care packages for professional, hassle‑free maintenance that will keep your property looking its best. Contact us today to set up a customized plan tailored to your needs. Unlike other landscapers' packages, we allow you to add unique services for an additional cost.`,
    noCard: true
  }
];

export default function ResidentialLawncare() {
  return (
    <section className="rl-container">
      <div className="rl-header">
        <h2 className="rl-main-title">Premium Residential Lawn Care Services</h2>
        <div className="rl-title-underline"></div>
        <p className="rl-subtitle">Professional maintenance tailored to your property's needs</p>
      </div>
      
      <div className="rl-services-grid">
        {residentialServices.map((service, index) => (
          <div 
            key={index} 
            className={`rl-service-card ${service.noCard ? 'rl-no-card' : ''} ${index % 2 === 0 ? 'rl-card-primary' : 'rl-card-accent'}`}
          >
            {service.badge && !service.noCard && (
              <div className="rl-service-badge">
                {service.badge}
              </div>
            )}
            
            <div className="rl-service-header">
              <h2 className="rl-service-title">{service.title}</h2>
            </div>

            {service.content && (
              <div className="rl-service-content">
                {service.content.map((paragraph, i) => (
                  <p key={i} dangerouslySetInnerHTML={{ __html: paragraph }} />
                ))}
              </div>
            )}

            {service.disclaimer && (
              <div className="rl-service-disclaimer">
                <div>
                  <h3>{service.disclaimer.title}</h3>
                  <p>{service.disclaimer.text}</p>
                </div>
              </div>
            )}

            {service.features && (
              <div className="rl-service-features">
                <ul className="rl-features-list">
                  {service.features.map((feature, i) => (
                    <li key={i} className="rl-feature-item">
                      <span className="rl-feature-text">{feature.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {service.closing && (
              <div className="rl-service-closing">
                <p>{service.closing}</p>
              </div>
            )}
          </div>
        ))}
      </div>
      
      <div className="rl-cta-section">
        <h2 className="rl-cta-title">Ready to Transform Your Lawn?</h2>
        <p className="rl-cta-subtitle">Contact us today for a free consultation and estimate. Our friendly experts will assess your property, answer any questions, and design a maintenance plan tailored to your needs and budget.</p>
        
        <div className="rl-cta-services">
          <p>You might also be interested in our:</p>
          <div className="rl-service-links">
            <Link to="/services/irrigation" className="rl-service-link">Irrigation Services</Link>
            <Link to="/services/sod-installation" className="rl-service-link">Sod Installation</Link>
            <Link to="/services/lawn-recovery-package" className="rl-service-link">Lawn Recovery Package</Link>
          </div>
        </div>
        
        <Link to="/contact" className="rl-cta-button">
          Get Your Free Quote
        </Link>
      </div>
    </section>
  );
}
